<template>
    <div class="custom-multi-select flex align-items-center gap-2 relative">
        <CustomLabel :name="name" :label="label" :required="required" :disabled="disabled" />
        <MultiSelect :id="name" :options="internalItems" :optionLabel="itemLabel" :optionValue="itemValue"
                     v-model="internalValue" :placeholder="computedPlaceholder"
                     :filter="filter" :disabled="disabled" :maxSelectedLabels="2"/>
    </div>
</template>

<script>
    import {useField} from "vee-validate";
    import MultiSelect from "primevue/multiselect";
    import CustomLabel from "./CustomLabel";

    export default {
        name: "CustomMultiSelect",

        components: {
            MultiSelect,
            CustomLabel,
        },

        props: {
            name: {
                type: String,
            },
            showLabel: {
                type: Boolean,
                default: true,
            },
            label: {
                type: String,
            },
            itemLabel: {
                default: "label",
            },
            itemValue: {
                type: String,
                default: "",
            },
            emptyValue: {
                type: Boolean,
                default: false,
            },
            items: {
                type: Array,
            },
            required: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: "",
            },
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
            modelValue: null,
            filter: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        emits: ["update:modelValue"],

        data() {
            return {
                internalItems: this.items ? [...this.items] : [],
            };
        },

        mounted() {
            if (this.emptyValue) {
                this.internalItems = [...this.items];
            }
        },

        computed: {
            internalValue: {
                get() { return this.modelValue; },
                set(value) { this.$emit("update:modelValue", value); },
            },
            computedPlaceholder() {
                if (this.noPlaceholder) return "";
                if (this.placeholder === "") return this.$t('message.inputs.multiselectPlaceholder');
                else return this.placeholder;
            },
        },

        watch: {
            items(newVal) {
                this.internalItems = [...newVal];
            },
            internalValue: {
                handler(value) {
                    if ((!this.items || this.items?.length === 0) && value && value.length > 0) {
                        this.internalItems = [...value];
                    }
                },
                deep: true,
            },
        },

        setup(props) {
            const {
                value: inputValue,
                errorMessage,
                handleBlur,
                handleChange,
                meta,
            } = useField(props.name, props.rules, {
                initialValue: props.modelValue,
            });

            return {
                handleChange,
                handleBlur,
                errorMessage,
                inputValue,
                meta,
            };
        },
    };
</script>

<style lang="scss">
    .custom-multi-select {
        .p-multiselect {
            width: 100%;
        }
    }
</style>
